import moment from "moment"
import { locale } from "core-js"

export default{
    formatDate:(date)=>{
        return moment(date,"YYYY-MM-DD").locale("pt-br").format("ddd, DD [de] MMMM [de] YYYY")
    }
}